import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router } from "@angular/router";
import { RoleEvaluatorService } from "../app/services/role-evaluator.service";

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(
    private readonly roleEvaluator: RoleEvaluatorService,
    private readonly router: Router
  ) { }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoutes = this.roleEvaluator.getAllowedRoutes();
    const requestedRoute = '/' + route.routeConfig?.path?.toLowerCase();
    if (requestedRoute === '/callback') {
      // Allow Okta or auth provider to handle the callback without redirecting
      console.log(`Access granted to ${requestedRoute}`);
      return true;
    }
    if (allowedRoutes.includes(requestedRoute)) {
      console.log(`Access granted to ${requestedRoute}`);
      return true;
    }
    console.warn(`Access denied to ${requestedRoute}`);
    // Redirect to first allowed route if available, otherwise to '/unauthorized'
    if (allowedRoutes.length > 0) {
      this.router.navigate([allowedRoutes[0]]);
    } else {
      this.router.navigate(['/unauthorized']);
    }
    return false;
  }
}